export default __webpack_public_path__ + "static/media/1.f0277b14.png";